(function () {
  function applyFix(slider) {
    if (!slider || !slider.classList.contains('swiper-initialized')) return;

    const swiper = slider.swiper;
    if (!swiper) return;

    // Only apply if needed (check current settings)
    if (swiper.params.slidesPerView !== 1 || 
        swiper.params.centeredSlides !== false || 
        swiper.params.spaceBetween !== 0) {
      
      swiper.params.slidesPerView = 1;
      swiper.params.centeredSlides = false;
      swiper.params.spaceBetween = 0;
      
      swiper.update();
    }
  }

  function fixCrossSellSwiper() {
    document
      .querySelectorAll('[data-cross-sells-slider="true"]')
      .forEach(applyFix);
  }

  // Initial run
  document.addEventListener('DOMContentLoaded', fixCrossSellSwiper);

  // Retry for async Swiper load
  setTimeout(fixCrossSellSwiper, 500);
  setTimeout(fixCrossSellSwiper, 1500);

  // 🔑 Observe cart re-renders (AJAX updates)
  // Target the cart specifically for better performance
  const cartObserver = new MutationObserver((mutations) => {
    let shouldFix = false;
    
    mutations.forEach((mutation) => {
      // Check if cart-related elements were added/modified
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Common WooCommerce cart containers
        const cartSelectors = [
          '.woocommerce-cart-form',
          '.cross-sells',
          '.cart_totals',
          '.wc-block-components-totals-wrapper',
          '[data-cart-content]'
        ];
        
        const target = mutation.target;
        const isCartRelated = cartSelectors.some(selector => 
          target.matches?.(selector) || 
          target.closest?.(selector) ||
          Array.from(mutation.addedNodes).some(node => 
            node.nodeType === 1 && (
              node.matches?.(selector) || 
              node.querySelector?.(selector)
            )
          )
        );
        
        if (isCartRelated) {
          shouldFix = true;
        }
      }
    });
    
    if (shouldFix) {
      // Small delay to ensure DOM is fully updated
      setTimeout(fixCrossSellSwiper, 100);
    }
  });

  // Observe the entire body but with more specific filtering
  cartObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Additional: Listen to WooCommerce-specific events
  if (typeof jQuery !== 'undefined') {
    jQuery(document.body).on('updated_cart_totals updated_checkout', function() {
      setTimeout(fixCrossSellSwiper, 300);
    });
  }

  // Listen for custom events that might indicate cart updates
  document.addEventListener('wc_fragments_loaded', fixCrossSellSwiper);
  document.addEventListener('wc_fragments_refreshed', fixCrossSellSwiper);
  
  // For modern WooCommerce blocks
  document.addEventListener('wc-blocks_added_to_cart', fixCrossSellSwiper);
  
  // Polling fallback (if all else fails)
  let lastCartHTML = '';
  setInterval(() => {
    const cartElement = document.querySelector('.cross-sells, .wc-block-cart');
    if (cartElement) {
      const currentHTML = cartElement.innerHTML;
      if (currentHTML !== lastCartHTML) {
        lastCartHTML = currentHTML;
        setTimeout(fixCrossSellSwiper, 200);
      }
    }
  }, 1000);
})();